export const environment = {
  production: true,
  wp: {
    url: 'https://myduensing.80.com-online.com',
    api: '/wp-json',
    auth: '/jwt-auth/v1',
    wordpress: '/wp/v2',
    events: '/tribe/events/v1',
    comon: '/com-on/v1'
  },
  notifications: {
      appId: '1309a1da-bc25-4602-a3dc-3b9c50bbe2bf',
      googleProjectNumber: '9128087425'
  },
  comon: {
    url: 'https://myduensing.com-on.local/api'
  }
};
